import { db } from "./firebase";

export interface IntervalsCredentials {
  apiKey: string;
  athleteId: string;
}

export async function loadCredentials(uid: string): Promise<IntervalsCredentials | null> {
  try {
    const doc = await db.collection("users").doc(uid).get();
    if (!doc.exists) return null;
    const data = doc.data()!;
    if (!data.intervalsApiKey || !data.intervalsAthleteId) return null;
    return { apiKey: data.intervalsApiKey, athleteId: data.intervalsAthleteId };
  } catch {
    return null;
  }
}

export async function saveCredentials(uid: string, creds: IntervalsCredentials): Promise<void> {
  await db.collection("users").doc(uid).set(
    {
      intervalsApiKey:   creds.apiKey,
      intervalsAthleteId: creds.athleteId,
      updatedAt: new Date().toISOString(),
    },
    { merge: true }
  );
}

/**
 * Account-synced app settings (wizard profile, interval-bank favorites/custom,
 * IronMan results, plan-action overrides). Stored as a map of localStorage-key →
 * JSON string under `settings` on the user doc, so it persists across browsers,
 * devices and origins (www vs apex). See COMPONENTS/cloudSync.ts.
 */
export async function loadUserSettings(uid: string): Promise<Record<string, string> | null> {
  try {
    const doc = await db.collection("users").doc(uid).get();
    if (!doc.exists) return null;
    const json = doc.data()!.settingsJson;
    return typeof json === "string" ? JSON.parse(json) : null;
  } catch {
    return null;
  }
}

// Stored as one JSON STRING (not a map) so each write fully replaces it — with a
// map field, Firestore's merge would deep-merge and never drop removed keys.
export async function saveUserSettings(uid: string, settings: Record<string, string>): Promise<void> {
  await db.collection("users").doc(uid).set(
    { settingsJson: JSON.stringify(settings), updatedAt: new Date().toISOString() },
    { merge: true }
  );
}
